<script setup>
import { useListStore } from '@/stores/ListStore'

const emit = defineEmits(['selected', 'update:modelValue', 'submit'])
const props = defineProps({
  submitSearch: { type: Boolean, default: false },
  output: Function,
  add: { type: String, required: false },
  select: { type: Function, required: false },
  url: { type: String, required: true },
  placeholder: { type: String, required: false, default: "Search..." },
})

function repeatSelected(val) {
  console.log(val)
  emit('selected', val)
}

const list = useListStore()
</script>
<template>
  <div>
    <searchable-input :url="props.url" :output="props.output" :placeholder="props.placeholder"
      :submit-search="props.submitSearch" @submit="emit('submit', $event)"
      @selected="repeatSelected" />
    <div v-show="list.searchQuery.length"
      class="overscroll-auto h-48 w-full overflow-auto rounded border border-t-0 border-slate-200 bg-white p-2 text-slate-900 dark:border-slate-700 dark:bg-slate-900/95 dark:text-slate-100">
      <router-link v-if="list.searchQuery.length && props.addUrl" :to="{
        name: props.addUrl,
        params: { name: list.searchQuery },
      }" class="block rounded p-2 hover:bg-gray-100 dark:hover:bg-slate-800">+ Add {{ list.searchQuery
        }}</router-link>
      <div v-for="r in list.searchResults" :key="r"
        class="my-1 cursor-pointer select-none rounded p-2 hover:bg-gray-100 dark:hover:bg-slate-800">
        <router-link :to="{
          path: list.urls.local + '/' + r.id,
        }" class="block rounded hover:bg-gray-100 dark:hover:bg-slate-800">{{ props.output(r) }}
        </router-link>
      </div>
    </div>
  </div>
</template>
